// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"002dd026","330":"ae86acb4","408":"adfe07b1","453":"cc96caa9","455":"1f2d1c39","533":"5fab5e3f","977":"9ec9fd9b"}[chunkId] + ".chunk.js";
};